const VestingClaimRow = ({ view, item, index, currentCycle, claimsTimes }) => {
  const formatTimestamp = (timestamp) => {
    if (!timestamp || timestamp === "0") return "--";

    const timestampToNumber = Number(timestamp);

    const date = new Date(timestampToNumber * 1000);

    const pad = (n) => String(n).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // months are 0-indexed
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  function areCongruent(a, b) {
    if (a == null || b == null) return false;
    return Math.abs(Number(a) - Number(b)) < 0.001;
  }

  return view === "table" ? (
    <tr
      className={
        currentCycle === null || item.id > currentCycle + 1 ? "dull" : ""
      }
    >
      <td>#{item?.id}</td>
      <td>{item?.percentage}%</td>
      <td>
        {item?.claimable?.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })}{" "}
        <span className="dullpara">RAIN</span>
      </td>
      <td>
        {item?.claimedRHS &&
        areCongruent(item?.claimedLHS, item?.claimedRHS) ? (
          <span className="greenpara">
            {item?.claimedLHS?.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
            /
          </span>
        ) : (
          <>
            {item?.claimedLHS?.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
            /
          </>
        )}

        <span className="dullpara">
          {item?.claimedRHS?.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}{" "}
          RAIN
        </span>
      </td>
      <td>
        <span className="midweight">
          {claimsTimes?.time?.[item.id - 1]
            ? formatTimestamp(claimsTimes?.time?.[item.id - 1])
            : "--"}
        </span>{" "}
        {/* 21:15:53 */}
      </td>
    </tr>
  ) : (
    <div
      className={`innerbox ${
        currentCycle === null || item.id > currentCycle + 1 ? "dullbox" : ""
      }`}
    >
      <div className="boxinner">
        <h6 className="mainhead">Month</h6>
        <p className="mainpara">#{item?.id}</p>
      </div>
      <div className="boxinner">
        <h6 className="mainhead">Percent</h6>
        <p className="mainpara">{item?.percentage}%</p>
      </div>
      <div className="boxinner">
        <h6 className="mainhead">Claimable</h6>
        <p className="mainpara">
          {" "}
          {item?.claimable?.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}{" "}
          <span className="dullpara">RAIN</span>
        </p>
      </div>
      <div className="boxinner">
        <h6 className="mainhead">Claimed</h6>
        <p className="mainpara">
          {item?.claimedRHS &&
          areCongruent(item?.claimedLHS, item?.claimedRHS) ? (
            <span className="greenpara">
              {item?.claimedLHS?.toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}
              /
            </span>
          ) : (
            <>
              {item?.claimedLHS?.toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}
              /
            </>
          )}

          <span className="dullpara">
            {item?.claimedRHS?.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}{" "}
            RAIN
          </span>
        </p>
      </div>
      <div className="boxinner">
        <h6 className="mainhead">Last Claimed</h6>
        <p className="mainpara">
          {" "}
          <span className="midweight">
            --
            {claimsTimes?.time?.[item.id - 1]
              ? formatTimestamp(claimsTimes?.time?.[item.id - 1])
              : "--"}
          </span>{" "}
          {/* 21:15:53 */}
        </p>
      </div>
    </div>
  );
};

export default VestingClaimRow;
